
import { useUserInfoStore } from "~/stores/userInfoStore"
export const getAssociationID = () => {
    const userInfoStore = useUserInfoStore()

    if(!userInfoStore.info){
        console.log('userInfoStore.info is null')
        return -1
    }
    if(!userInfoStore.info.organization_id){
        console.log('userInfoStore.info.organization_id is null')
        return -1
    }
    
    if((!!userInfoStore.info.organization) && (userInfoStore.info.organization.organization_type == '协会')){
        return userInfoStore.info.organization.id
    } else if((!!userInfoStore.info.hotel) && (userInfoStore.info.hotel.association_id)) {
        return userInfoStore.info.hotel.association_id || -1
    }
    
    return -1
}